const L = "is-mobile-full-width", _ = "data-mobile-full-width";
export {
  L as MOBILE_FULL_WIDTH_CLASSNAME,
  _ as MOBILE_FULL_WIDTH_DATA_ATTRIBUTE
};
